import { ASSET_TYPE_LIST } from "@quest-finance/quest-fe-shared/dist/application/constants/assetTypes";
import { USAGE_TYPE_LABELS } from "@quest-finance/quest-fe-shared/dist/application/constants/usageTypes";
import diffInYears from "date-fns/differenceInYears";

export interface AssetLabels {
  assetCategoryLabel: string | undefined;
  assetTypeLabel: string | undefined;
  usageTypeLabel: string | undefined;
}

export const resolveAssetLabels = (asset: {
  assetTypeCategory?: string | null;
  assetType?: string | null;
  usageType?: string | null;
}): AssetLabels => {
  const category = ASSET_TYPE_LIST.find(
    (item) => item.value === asset.assetTypeCategory
  );
  const assetType = category?.subTypes.find(
    (type) => type.value === asset.assetType
  );

  return {
    assetCategoryLabel: category?.label,
    assetTypeLabel: assetType?.label,
    usageTypeLabel: USAGE_TYPE_LABELS[asset.usageType as string] as
      | string
      | undefined,
  };
};

export const calcualteAgeEOT = (
  manufactureYear: number,
  repaymentTermMonth: number
): number => {
  const currentYear = new Date().getFullYear();
  const ageSinceManufacture = diffInYears(
    new Date(currentYear, 0, 0),
    new Date(manufactureYear as number, 0, 0)
  );
  const loanTermYears = repaymentTermMonth / 12;

  return ageSinceManufacture + loanTermYears;
};

export const calculateLvr = (
  amountFinanced: number,
  brokerageNominalWithGst: number,
  value?: number | null
): number => {
  let lvr = 0;

  if (value) {
    const amoundFunded = amountFinanced + brokerageNominalWithGst;
    lvr = (amoundFunded / value) * 100;
  }

  return lvr;
};
